export default "__VITE_ASSET__L9DoAyLw__"